<template>
  <div id="app">
    <!--
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>
    <router-view/>
    -->
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <b-alert variant="danger" :show="loadingError != ''">{{
            loadingError
          }}</b-alert>
          <h4 class="text-center py-3" v-if="loading">Loading...</h4>
          <div v-else>
            <div class="logo m-auto my-3 py-3">
              <a :href="settings.officialWebsite" target="_blank">
                <img :src="logoUrl" alt="" class="img-fluid" />
              </a>
            </div>
            <hr />
            <div id="nav">
              <a :href="privacyUrl" target="_blank" class="m-3"
                >Privacy Policy</a
              >
              <a
                :href="'mailto:' + settings.officialEmail"
                target="_blank"
                class="m-3"
                >{{ settings.officialEmail }}</a
              >
              <a
                :href="'tel:' + settings.officialPhone"
                target="_blank"
                class="m-3"
                >{{ settings.officialPhone }}</a
              >
            </div>
            <hr />
            <div class="my-3 app-body">
              <booking-form />
            </div>

            <div class="footer py-1 mt-3 bg-light">
              <p>{{ copyrightInfo }}</p>
              <p class="small">
                {{ settings.senderAddress }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
#app {
  margin: 20px auto;
  text-align: center;

  .logo {
    max-width: 250px;
  }
  .app-body {
    min-height: 200px;
  }
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import BookingForm from "./components/booking_form/BookingForm";

export default {
  name: "App",
  data() {
    return {
      loading: false,
    };
  },
  components: {
    BookingForm,
  },
  computed: {
    ...mapGetters(["getSettings", "getOffers", "hasLastError", "getLastError"]),
    loadingError() {
      let vm = this;

      if (vm.hasLastError) {
        //return ret.exception;
        return vm.getLastError;
      }

      return "";
    },
    appName() {
      let vm = this;
      return vm.getSettings ? vm.getSettings.appName : "";
    },
    privacyUrl() {
      //return process.env.VUE_APP_PRIVACY_URL;
      let vm = this;
      return vm.getSettings ? vm.getSettings.officialPrivacyUrl : "";
    },
    tocUrl() {
      //return process.env.VUE_APP_TOC_URL;
      let vm = this;
      return vm.getSettings ? vm.getSettings.officialToCUrl : "";
    },
    logoUrl() {
      let vm = this;
      return vm.getSettings ? vm.getSettings.logoUrl : "";
    },
    copyrightInfo() {
      let vm = this;
      return vm.getSettings ? vm.getSettings.copyrightInfo : "";
    },
    settings() {
      let vm = this;
      const ret = vm.getSettings;

      if (ret.appName && this.loading) {
        this.endLoading();
      }

      return vm.getSettings;
    },
  },
  mounted() {
    this.startLoading();
    this.init();
  },
  methods: {
    ...mapActions(["fetchSettings", "fetchOffers", "fetchOfferProgrammes"]),
    async init() {
      let vm = this;
      vm.startLoading();
      try {
        await vm.fetchSettings();
        await vm.fetchOfferProgrammes();
        await vm.fetchOffers();
        vm.endLoading();
      } catch (err) {
        this.$swal({
          title: "Error",
          text: "Unable to load data",
          icon: "error",
        });
      }
    },
    startLoading() {
      this.loading = true;
    },
    endLoading() {
      this.loading = false;
    },
  },
};
</script>
